import {ENDPOINT_ADMIN_CC_CODE_ACTIVATE, ENDPOINT_ADMIN_CC_CODES_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const Emitter = require('mn-utils/Emitter');
const getValues = require('mn-utils/values');
const {
  apiRequestAdmin,
} = require('../ws');


const mockCccodeMode$ = new Emitter({
  BTC: {
    code: 'BTC',
    enabled: true,
  },
  ETH: {
    code: 'ETH',
    enabled: true,
  },
});


export function apiAdminCccodeList(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: getValues(mockCccodeMode$.getValue()),
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_CC_CODES_LIST, params);
}
export function apiAdminCccodeActivate(params) {
  if (process.env.MOCK) {
    mockCccodeMode$.set(reduce(params.items, (a, {
      cc_code: code,
      enable: enabled,
    }) => {
      a[code] = {
        code,
        enabled,
      };
      return a;
    }, {}));
    return CancelablePromise.delay(500, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_CC_CODE_ACTIVATE, params);
}
export function apiAdminCccodeActivateOne(params) {
  return apiAdminCccodeActivate({
    items: [params],
  });
}
export function apiAdminCccodeEnable(params) {
  return apiAdminCccodeActivateOne({
    ...params,
    enable: true,
  });
}
export function apiAdminCccodeDisable(params) {
  return apiAdminCccodeActivateOne({
    ...params,
    enable: false,
  });
}
